(() => {
  if (window.__ME_PNG_DOWNLOAD_V732__) return;
  window.__ME_PNG_DOWNLOAD_V732__ = true;

  const safeName = (name, fallback) => {
    const base = String(name || fallback || 'momentsetched-image.png')
      .replace(/[\\/:*?\"<>|]+/g, '-')
      .trim();
    return /\.png$/i.test(base) ? base : base.replace(/\.[a-z0-9]+$/i, '') + '.png';
  };

  async function fetchImage(url) {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(`Image download failed (${response.status})`);
    const blob = await response.blob();
    return createImageBitmap(blob);
  }

  async function convertToPng(url) {
    const bitmap = await fetchImage(url);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const context = canvas.getContext('2d', { alpha: true });
    context.drawImage(bitmap, 0, 0);
    bitmap.close?.();
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('PNG conversion failed.')), 'image/png', 1);
    });
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-me-png-download]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Preparing PNG…';

    try {
      const blob = await convertToPng(button.dataset.url);
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = safeName(button.dataset.filename, 'momentsetched-image.png');
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
    } catch (error) {
      console.error('[Moments v7.3.3] PNG download failed.', error);
      window.open(button.dataset.url, '_blank', 'noopener');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  });
})();
